import axios from "axios";

const apiOrigin = process.env.VUE_APP_API_ORIGIN || ''
const baseApi = process.env.VUE_APP_BASE_API || '/api/v1'
const uploadUrl = apiOrigin + baseApi + '/upload'

export function upload(file) {
    const token = localStorage.getItem('token')
    const forms = new FormData();
    //这里的file表示给后台传的属性名字，这里看接口文档需要传的的属性
    forms.append("file", file.file); // 获取上传图片信息
    return axios.post(uploadUrl, forms, {
        headers: {
            "content-type": "multipart/form-data",
            "Authorization": token,
        },
    })
}